var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2389 1.89877C15.6594 3.3193 15.6594 5.62244 14.2389 7.04297C12.8184 8.4635 10.5152 8.4635 9.0947 7.04297C7.67416 5.62244 7.67416 3.3193 9.0947 1.89877C10.5152 0.478241 12.8184 0.478241 14.2389 1.89877",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2116 12.0793C14.8585 11.5386 13.271 11.2407 11.6668 11.2407C7.45016 11.2407 3.3335 13.2897 3.3335 16.4407V17.4824C3.3335 18.0574 3.80016 18.5241 4.37516 18.5241H14.1804",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 21.6667C16.0823 21.6667 13.75 19.3354 13.75 16.4583C13.75 13.6417 16.1458 11.2469 18.9625 11.25C21.8375 11.2521 24.1667 13.5833 24.1667 16.4583C24.1667 19.3344 21.8354 21.6667 18.9583 21.6667",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5336 16.4177H18.4253V14.3104",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.f700eb77f2d6ef6d5f95a66074014d75.svg";
export { ForwardRef as ReactComponent };